import ComplianceStatusBadge from '../components/ReturnIntakesScanner/ScannedItemCard/ComplianceStatusBadge';
import { COMPLIANCE_STATUS_CLASSES, DEFAULT_STATUS_CLASS } from './statusChip';
import { ColumnConfig } from '@/components/table/Table';
import { appUrl } from '@/utils/appUrl';

interface ColumnHelpers {
  formatDate: (date: string | null | undefined) => string;
}

export const getNotReportedShippingsColumns = ({
  formatDate,
}: ColumnHelpers): ColumnConfig[] => [
  {
    label: 'ID Pedido',
    field: 'shippingNumber',
    render: (value) => (
      <span 
        className='font-bold text-blue-600 text-[14px] cursor-pointer hover:underline'
        onClick={() => {
          window.open(appUrl(`/business/shipping/${value}`), '_blank');
        }}
      >
        {value}
      </span>
    ),
  },
  {
    label: 'Conductor',
    field: 'driverName',
    render: (value, item) => (
      <span 
        className='font-bold text-gray-900 text-[14px] cursor-pointer hover:underline'
        onClick={() => {
          window.open(appUrl(`/business/drivers/${item.driverId}`), '_blank');
        }}
      >
        {value}
      </span>
    ),
  },
  {
    label: 'Comercio',
    field: 'commerceName',
    render: (value) => (
      <span className='text-[13px] font-bold text-gray-700 uppercase tracking-tight'>
        {value || '-'}
      </span>
    ),
  },
  {
    label: 'Cumplimiento',
    field: 'complianceCommercialName',
    render: (value, item) => {
      const classes = COMPLIANCE_STATUS_CLASSES[item.complianceName] || DEFAULT_STATUS_CLASS;
      return (
        <ComplianceStatusBadge
          commercialName={value}
          classes={classes}
          hideIcon={true}
        />
      );
    },
  },
  {
    label: 'Fecha',
    sortable: true,
    field: 'createdAt',
    render: (value) => {
      const formatted = formatDate(value);
      if (formatted === '-') return <span className='text-gray-400'>-</span>;
      const [date, time] = formatted.split(' ');
      return (
        <div className='flex flex-col leading-tight text-gray-800'>
          <span className='text-[13px] font-bold'>{date}</span>
          <span className='text-[11px] font-medium text-gray-500'>{time}</span>
        </div>
      );
    },
  },
];
